import { FC, useMemo } from 'react';

import CustomMultiSelect from '@/components/Filtering/CustomMultiSelect.tsx';

import useConfig from '@/hooks/useConfig.ts';
import useFilters from '@/hooks/useFilters.ts';

import { useFilterStore } from '@/stores/filterStore.ts';

const PractitionerSelect: FC = () => {
    const { location_key } = useConfig();
    const { practitioner_options } = useFilters();
    const selected_practitioners = useFilterStore((state) => state.selected_practitioners);

    const current_selected_practitioners = useMemo(() => {
        return selected_practitioners[location_key] ?? [];
    }, [selected_practitioners, location_key]);

    const handleSelectAll = (): void => {
        if (current_selected_practitioners.length === practitioner_options.length) {
            useFilterStore.setState((state) => ({
                selected_practitioners: {
                    ...state.selected_practitioners,
                    [location_key]: [],
                },
            }));
        } else {
            useFilterStore.setState((state) => ({
                selected_practitioners: {
                    ...state.selected_practitioners,
                    [location_key]: practitioner_options.map((option) => option.value),
                },
            }));
        }
    };

    const handleTogglePractitioner = (id: string): void => {
        const new_selected = current_selected_practitioners.includes(id)
            ? current_selected_practitioners.filter((value) => value !== id)
            : [...current_selected_practitioners, id];

        useFilterStore.setState((state) => ({
            selected_practitioners: {
                ...state.selected_practitioners,
                [location_key]: new_selected,
            },
        }));
    };

    const display_text = useMemo(() => {
        if (current_selected_practitioners.length === 0) return 'Keine Behandler:innen';

        if (current_selected_practitioners.length === practitioner_options.length) {
            return `Alle Behandler:innen (${practitioner_options.length})`;
        }

        return `Ausgewählte Behandler:innen (${current_selected_practitioners.length})`;
    }, [current_selected_practitioners, practitioner_options]);

    return (
        <CustomMultiSelect
            label="Alle Behandler:innen"
            displayText={display_text}
            options={practitioner_options}
            selected={current_selected_practitioners}
            handleToggle={handleTogglePractitioner}
            handleSelectAll={handleSelectAll}
            showWarningIfNoneIsSelected
        />
    );
};

export default PractitionerSelect;
